import React, { Component } from "react";
import {
	FormGroup,
	ControlLabel,
	FormControl,
	Row,
	Col,
} from "react-bootstrap";
import Select from "react-select";
import "react-select/dist/react-select.css";
import DateTime from "react-datetime";
import "style/react-datetime.css";

import { IS_VALID } from "utils";

import Loader from "../../Loader";
import Dropzone from "react-dropzone";
import ic_add_image from "../../../assets/image/ic_add_image.svg";

class Create extends Component {
	render() {
		let { AppThumb, actions } = this.props;

		let {
			isLoadingAction,

			title,
			browser,
			url,
			image,
			imageBg,
			startDate,
			endDate,
			sort,

			browserOptions,
		} = AppThumb;

		let requiredSpan = <span style={{ color: "red" }}>*</span>;

		let imageSrc = ic_add_image,
			imageStyle = {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				margin: "auto",
				width: "100px",
				height: "100%",
			},
			imageDropZoneStyle = {
				display: "inline-block",
				verticalAlign: "top",
			},
			imageIsHideX = {
				display: "none",
			};

		if (IS_VALID(image)) {
			imageSrc = image.preview || image.url;
			imageStyle = {
				...imageStyle,
				width: "",
				maxWidth: "100%",
				maxHeight: "100%",
			};
			imageDropZoneStyle = {
				verticalAlign: "middle",
			};
			imageIsHideX = {};
		}

		let imageBgSrc = ic_add_image,
			imageBgStyle = {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				margin: "auto",
				width: "100px",
				height: "100%",
			},
			imageBgDropZoneStyle = {
				display: "inline-block",
				verticalAlign: "top",
			},
			imageBgIsHideX = {
				display: "none",
			};

		if (IS_VALID(imageBg)) {
			imageBgSrc = imageBg.preview || imageBg.url;
			imageBgStyle = {
				...imageStyle,
				width: "",
				maxWidth: "100%",
				maxHeight: "100%",
			};
			imageBgDropZoneStyle = {
				verticalAlign: "middle",
			};
			imageBgIsHideX = {};
		}
		return (
			<form>
				<Loader loading={isLoadingAction} />
				<FormGroup>
					<ControlLabel>Title {requiredSpan}</ControlLabel>
					<FormControl
						type="text"
						placeholder="Enter Title..."
						value={title}
						onChange={(e) => {
							actions.setValue({
								title: e.target.value,
							});
						}}
					/>
				</FormGroup>
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>Browser {requiredSpan}</ControlLabel>
							<Select
								options={browserOptions}
								value={browser}
								clearable={false}
								onChange={(value) => {
									let stateToUpdate = {
										browser: value,
									};

									actions.setValue(stateToUpdate);
								}}
							/>
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>URL {requiredSpan}</ControlLabel>
							<FormControl
								type="text"
								placeholder="Enter Url..."
								value={url}
								onChange={(e) => {
									actions.setValue({
										url: e.target.value,
									});
								}}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>Start Date {requiredSpan}</ControlLabel>
							<DateTime
								dateFormat={"MMM DD, YYYY"}
								timeFormat="hh:mm A"
								value={startDate}
								onChange={(datetime) => {
									actions.setValue({ startDate: datetime });
								}}
								inputProps={{
									placeholder: "Start Date",
								}}
							/>
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup>
							<ControlLabel>End Date {requiredSpan}</ControlLabel>
							<DateTime
								dateFormat={"MMM DD, YYYY"}
								timeFormat="hh:mm A"
								value={endDate}
								onChange={(datetime) => {
									actions.setValue({ endDate: datetime });
								}}
								inputProps={{
									placeholder: "End Date",
								}}
							/>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col md={6}>
						<ControlLabel>Sort {requiredSpan}</ControlLabel>
						<FormControl
							type="number"
							placeholder="Enter Sort..."
							value={sort}
							onChange={(e) => {
								actions.setValue({
									sort: e.target.value,
								});
							}}
						/>
					</Col>
				</Row>
				<br/>
				<Row>
					<Col md={6}>
						<FormGroup style={{ position: "relative" }}>
							<ControlLabel>Image {requiredSpan}</ControlLabel>
							<div
								style={{
									position: "absolute",
									width: "30px",
									height: "30px",
									background: "red",
									paddingTop: "4px",
									top: "12px",
									right: "-12px",
									textAlign: "center",
									borderRadius: "50px",
									fontWeight: "600",
									cursor: "pointer",
									...imageIsHideX,
								}}
								onClick={() => {
									actions.setValue({ image: null });
								}}
							>
								x
							</div>
							<Dropzone
								style={{
									position: "",
									width: "100%",
									height: "200px",
									border: "1px solid #e1e1e1",
									borderRadius: "0px",
									backgroundColor: "#f5f5f5",
									...imageDropZoneStyle,
								}}
								accept="image/*"
								multiple={false}
								onDropAccepted={(acceptedArray) => {
									actions.setValue({ image: acceptedArray[0] });
								}}
							>
								<img style={imageStyle} src={imageSrc} />
							</Dropzone>
						</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup style={{ position: "relative" }}>
							<ControlLabel>Image Background {requiredSpan}</ControlLabel>
							<div
								style={{
									position: "absolute",
									width: "30px",
									height: "30px",
									background: "red",
									paddingTop: "4px",
									top: "12px",
									right: "-12px",
									textAlign: "center",
									borderRadius: "50px",
									fontWeight: "600",
									cursor: "pointer",
									...imageBgIsHideX,
								}}
								onClick={() => {
									actions.setValue({ imageBg: null });
								}}
							>
								x
							</div>
							<Dropzone
								style={{
									position: "",
									width: "100%",
									height: "200px",
									border: "1px solid #e1e1e1",
									borderRadius: "0px",
									backgroundColor: "#f5f5f5",
									...imageBgDropZoneStyle,
								}}
								accept="image/*"
								multiple={false}
								onDropAccepted={(acceptedArray) => {
									actions.setValue({ imageBg: acceptedArray[0] });
								}}
							>
								<img style={imageBgStyle} src={imageBgSrc} />
							</Dropzone>
						</FormGroup>
					</Col>
				</Row>
			</form>
		);
	}
}

import { connect } from "react-redux";

function mapStateToProps(state) {
	let { AppThumb } = state;

	return {
		AppThumb,
	};
}

export default connect(mapStateToProps)(Create);



// WEBPACK FOOTER //
// ./components/AppThumb/FormContainer/Create.js